module.exports = __webpack_public_path__ + "static/img/pic-4.019fb10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/pic-4.jpg
// module id = eudY
// module chunks = 1